// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7468":"css/app.6979","9023":"css/admin-app.6979"}[chunkId] + ".css";
};